import { httpGetRequest } from "clients/phronesisClient"
import {
	GROWTH_PROFILING_TREE,
	GROWTH_PROFILING_CUSTOMER_SEGMENTATION,
} from "constants/paths"
import { concatValues } from "helpers/service"
import { PARAMETER_KEYS } from "constants/parameters"
import {
	CustomerSegmentationResponse,
	GrowthProfilingParams,
	GrowthProfilingResponse,
} from "./Shared/interfaces"

const NUMBER_RETRIES = 0

export const getGrowthTree = async (
	cancelToken: any,
	params: GrowthProfilingParams
): Promise<GrowthProfilingResponse> => {
	const parsedParams = prepareRequestParameters(params)
	return httpGetRequest<GrowthProfilingResponse>(
		GROWTH_PROFILING_TREE,
		parsedParams,
		undefined,
		cancelToken,
		undefined,
		NUMBER_RETRIES
	)
}

export const prepareRequestParameters = (
	params: GrowthProfilingParams
): Record<string, string> => {
	const { filters, customers, dateInterval } = params

	const parsedParams = Object.keys(filters)
		.filter((key) => filters[key].length)
		.reduce(
			(currentValue, key) => ({
				...currentValue,
				[PARAMETER_KEYS[key]]: concatValues(filters[key]),
			}),
			{}
		)
	return { ...parsedParams, customers, ...dateInterval }
}

export const getGrowthProfilingDescription = async (
	cancelToken: any,
	params: GrowthProfilingParams
): Promise<CustomerSegmentationResponse> => {
	const parsedParams = prepareRequestParameters(params)
	return httpGetRequest<CustomerSegmentationResponse>(
		GROWTH_PROFILING_CUSTOMER_SEGMENTATION,
		parsedParams,
		undefined,
		cancelToken,
		undefined,
		NUMBER_RETRIES
	)
}
